module.exports = __webpack_public_path__ + "img/mock-up.f569ada9.png";